import { t } from "@/lib/i18n";

/** Server error codes (raised by private.fail) → messages for people, in the current language. */
function messageFor(code: string): string {
  const m = t().errors;
  return m[code] ?? m.unknown!;
}

export class AppError extends Error {
  readonly code: string;
  readonly detail?: string;
  constructor(code: string, detail?: string) {
    super(messageFor(code));
    this.code = code;
    this.detail = detail;
  }
}

/** Normalise PostgREST / fetch errors into AppError. */
export function toAppError(e: unknown): AppError {
  if (e instanceof AppError) return e;
  const err = e as { message?: string; details?: string; code?: string; name?: string };
  const msg = err?.message ?? "";
  if (err?.name === "TypeError" || /Failed to fetch|NetworkError|Load failed/i.test(msg)) return new AppError("network", msg);
  const code = /^[a-z_]+$/.test(msg) ? msg : "unknown";
  return new AppError(code, err?.details ?? msg);
}

/** Resolved at render time, so a cached error follows a language switch. */
export function errorMessage(e: unknown): string {
  return messageFor(toAppError(e).code);
}
